export default "__VITE_ASSET__BZedvfmZ__"